import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const SearchIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M17.4476 17.4476L11.8654 11.8654M11.8654 11.8654C13.0404 10.6904 13.7672 9.0672 13.7672 7.27421C13.7672 3.68824 10.8602 0.781235 7.27421 0.781235C3.68824 0.781235 0.781235 3.68824 0.781235 7.27421C0.781235 10.8602 3.68824 13.7672 7.27421 13.7672C9.0672 13.7672 10.6904 13.0404 11.8654 11.8654Z" stroke={color} strokeWidth="1.5" />
  </Svg>
);

SearchIcon.displayName = 'SearchIcon';
